<template>
  <my-view :GetOrderDetail="GetOrderDetail" :OverTimecancelOrder="OverTimecancelOrder" :ExportExcel="ExportExcel" :CompleteOrderBatch="CompleteOrderBatch" :GetCancelOrder="GetCancelOrder" :CancelOrder="CancelOrder" :AddShopCart="AddShopCart"></my-view>
</template>

<script>
import {
  GetOrderDetail,
  OverTimecancelOrder,
  ExportExcel,
  CompleteOrderBatch,
  GetCancelOrder,
  CancelOrder,
} from "@/pages/page1/api/modules/order";
import { AddShopCart } from "@/pages/page1/api/modules/shoppingCart";

import MyView from "@/pages/publicView/personalCenter/myOrder/orderDetail_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      GetOrderDetail,
      OverTimecancelOrder,
      ExportExcel,
      CompleteOrderBatch,
      GetCancelOrder,
      CancelOrder,
      AddShopCart,
    };
  },
};
</script>